// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"221":"4c17fdd4","532":"8b15d99f"}[chunkId] + ".chunk.css";
};